module.exports = __webpack_public_path__ + "img/recmember.9c328f20.jpg";